/* tt-mg.js: the Mystery Gift test. Owner: departments/web-cro/mystery_gift_test.md. Built 2026-10-27.

   Two jobs:
   1. The PDP block (snippets/tt-mg-block.liquid): 1 bag / 2 bags, the second-bag picker, and Add to Cart
      for two bags. Two bags are added the way Kopstorm's add-on checkbox adds its item (kv-pdp.js): a
      capture-phase submit listener adds bag 2 and the gift through /cart/add.js, then re-submits the form,
      so Dawn's product-form adds bag 1 and renders the drawer exactly as it always does.
   2. The cart rule, on every page: after any cart write by anyone, the cart is read through
      sections/tt-mg-cart.liquid and corrected. Arm B: two or more bags = exactly one gift. Control and
      ineligible visitors: no gift. Dormant (test off): a gift already there stays while the cart has two
      bags, and is never added. The checkout guard (apps/tote-gift) refuses whatever slips past this.

   The cart-write watcher wraps window.fetch and XMLHttpRequest, like tote-survey-kopstorm.js. Our own
   writes go through rawFetch so they never trigger the rule while it is half way through. */
(function () {
  'use strict';
  var T = window.ttMg;
  if (!T || window.__ttMgLoaded) return;
  window.__ttMgLoaded = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var rawFetch = window.fetch.bind(window);
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* ---------- money ---------- */
  // Mirrors assets/tt-cd3.js: outside EUR the TØTE pair is 2 x (EUR 35 converted and rounded up).
  var ROUNDING_MINOR = { GBP: 100, CHF: 100, SEK: 100, DKK: 100, PLN: 100, CZK: 100, HUF: 10000, USD: 100 };
  var TOTE_PAIR_UNIT_EUR = 3500;
  function rate() { var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate); return r > 0 ? r : 1; }
  function localOf(eurMinor, r, inc) { return Math.ceil(eurMinor * r / inc - 1e-9) * inc; }
  function makeMoney(sample) {
    // sample is 123400 minor units printed by Liquid's money filter, e.g. "€1.234", "€1.234,00", "1 234,00 kr"
    var m = /1([^0-9]?)234(?:([.,])(00))?/.exec(sample || '');
    if (!m) return function (x) { return (x / 100).toFixed(2); };
    var pre = sample.slice(0, m.index), post = sample.slice(m.index + m[0].length);
    var thou = m[1] || '', dec = m[2] || '', decimals = m[3] ? 2 : 0;
    return function (minor) {
      var n = minor / 100;
      var parts = (decimals ? n.toFixed(2) : String(Math.round(n))).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return pre + whole + (decimals ? dec + parts[1] : '') + post;
    };
  }
  // Intelligems price tests (SIV 59/54/49): the visitor's arm price, in currency units, for a tested variant.
  function igPrice(v, fallback) {
    var ig = window.igData && window.igData.price;
    if (!ig || typeof ig.getPriceByVariantId !== 'function') return fallback;
    try { var p = ig.getPriceByVariantId(String(v)); if (p != null && p !== '' && !isNaN(parseFloat(p))) return Math.round(parseFloat(p) * 100); } catch (e) {}
    return fallback;
  }
  function igCompare(v, fallback) {
    var ig = window.igData && window.igData.price;
    if (!ig || typeof ig.getComparePriceByVariantId !== 'function') return fallback;
    try { var p = ig.getComparePriceByVariantId(String(v)); if (p != null && p !== '' && !isNaN(parseFloat(p))) return Math.round(parseFloat(p) * 100); } catch (e) {}
    return fallback;
  }

  /* ---------- the PDP block ---------- */
  function initBlock(el) {
    if (el.__ttMg) return;
    // The script loads async and may run while the page is still being parsed: wait until the product form exists.
    if (!document.getElementById(el.getAttribute('data-form'))) return;
    el.__ttMg = true;
    var D; try { D = JSON.parse(el.querySelector('[data-tt-mg-data]').textContent); } catch (e) { return; }
    if (D.capped) console.warn('[tt-mg] collection ' + D.capped + ' has more than 50 products; the picker misses some.');
    var money = makeMoney(D.fmt);
    var seen = {}, bags = [];
    D.bags.forEach(function (b) { if (!seen[b.id]) { seen[b.id] = 1; bags.push(b); } });
    var fams = D.fams.filter(function (f) { return bags.some(function (b) { return b.f === f.k; }); });
    var main = D.main;
    var form = document.getElementById(el.getAttribute('data-form'));
    if (!form) return;
    var second = bags.filter(function (b) { return b.f === main.f && b.a && b.id !== main.id; })[0] ||
                 bags.filter(function (b) { return b.a && b.id !== main.id; })[0];
    if (!second) { el.remove(); return; }
    var tier = 1;
    var radios = el.querySelectorAll('.tt-mg__radio');
    var two = el.querySelector('[data-tt-tier="2"]');
    var one = el.querySelector('[data-tt-tier="1"]');
    var err = el.querySelector('[data-tt-mg-err]');

    function priceOf(b) { return igPrice(b.v, b.p); }
    function compareOf(b) { var c = igCompare(b.v, b.c); return c > priceOf(b) ? c : priceOf(b); }
    function mainVariant() { var i = form.querySelector('[name="id"]'); return i ? Number(i.value) : main.v; }
    function pairTotal(a, b) {
      var sum = priceOf(a) + priceOf(b);
      if (!(a.tote && b.tote)) return sum;
      var cur = D.currency;
      if (cur === 'EUR') return Math.min(sum, 2 * TOTE_PAIR_UNIT_EUR);
      var inc = ROUNDING_MINOR[cur];
      if (!inc) return sum;
      return Math.min(sum, 2 * localOf(TOTE_PAIR_UNIT_EUR, rate(), inc));
    }
    function label(b) { return b.t; }
    // Unused since 2026-10-27: Hajo wants the full product name under each picker card.
    function colourOf(b) {
      var t = b.t;
      if (t.indexOf(' | ') > -1 && !/\| Stitched$/.test(t)) return t.split(' | ').slice(1).join(' | ');
      return t.replace(/ \| Stitched$/, '').replace(/ (TØTE Bag|Duffel Bag|Waist Bag|Laptop Sleeve.*)$/, '').trim() || t;
    }

    el.__ttRender = function () { render(); };
    function render() {
      var m = { v: mainVariant(), p: main.p, c: main.c, tote: main.tote };
      var tot = pairTotal(m, second), was = compareOf(m) + compareOf(second);
      el.querySelector('[data-tt-mg-two-now]').textContent = money(tot);
      var w = el.querySelector('[data-tt-mg-two-was]');
      w.textContent = was > tot ? money(was) : ''; w.hidden = !(was > tot);
      el.querySelector('[data-tt-mg-b2-img]').src = second.img;
      el.querySelector('[data-tt-mg-b2-name]').textContent = label(second);
      var sp = priceOf(second), pr = tot - priceOf(m);
      el.querySelector('[data-tt-mg-b2-price]').textContent = money(sp) + (pr < sp ? '  ' + D.s.pair + ' ' + money(tot) : '');
      el.querySelector('[data-tt-mg-bags]').hidden = tier !== 2;
      two.classList.toggle('is-on', tier === 2); one.classList.toggle('is-on', tier === 1);
      atc(tot, was);
    }

    // The buy button and the sticky button: tier 2 says "Add 2 bags to cart" and shows the pair total in our
    // own span. The theme's price spans are hidden, not rewritten, because Intelligems rewrites those.
    // Buttons are prepared lazily: with an early start the sticky button may not be parsed yet, so every render
    // re-reads the page and prepares any button it has not seen.
    var buttons = [];
    function prepButtons() {
    [].forEach.call(document.querySelectorAll('[data-kv-submit], [data-kv-sticky-btn]'), function (b) {
      if (b.__ttSpan) return;
      buttons.push(b);
      var lab = b.querySelector('[data-kv-submit-label]');
      if (!lab) {
        // The sticky button's label is a bare text node. Wrap it in the span kv-pdp.js already looks for, so
        // its variant-change rewrite lands in the span and never wipes our price span off the button.
        var tn = [].filter.call(b.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); })[0];
        if (tn) { lab = document.createElement('span'); lab.setAttribute('data-kv-submit-label', ''); lab.textContent = tn.textContent.trim(); b.replaceChild(lab, tn); }
      }
      b.__ttLab = lab;
      var s = document.createElement('span'); s.className = 'tt-mg-atc'; s.hidden = true; b.appendChild(s); b.__ttSpan = s;
    });
    }
    function atc(tot, was) {
      prepButtons();
      buttons.forEach(function (b) {
        var on = tier === 2 && !b.disabled;
        b.classList.toggle('tt-mg-two', on);
        if (b.__ttLab) {
          if (on) { if (b.__ttOrig == null) b.__ttOrig = b.__ttLab.textContent; b.__ttLab.textContent = D.s.atc2; }
          else if (b.__ttOrig != null) { b.__ttLab.textContent = b.__ttOrig; b.__ttOrig = null; }
        }
        b.__ttSpan.hidden = !on;
        b.__ttSpan.innerHTML = on ? (was > tot ? '<s>' + money(was) + '</s> ' : '') + money(tot) : '';
      });
    }

    [].forEach.call(radios, function (r) {
      r.addEventListener('change', function () { if (r.checked) { tier = Number(r.value); err.hidden = true; render(); } });
    });
    two.addEventListener('click', function (e) {
      if (tier === 2 || e.target.closest('[data-tt-mg-open]')) return;
      var r = two.querySelector('.tt-mg__radio'); r.checked = true; r.dispatchEvent(new Event('change'));
    });
    el.querySelector('[data-tt-mg-open]').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openPicker(); });

    /* the picker: a bottom sheet on a phone, a centred window from 750px */
    var sheet = null, curFam = null;
    function openPicker() {
      if (!sheet) {
        sheet = document.createElement('div');
        sheet.className = 'tt-mg-pick';
        sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', D.s.title);
        sheet.innerHTML = '<div class="tt-mg-pick__bg" data-x></div><div class="tt-mg-pick__box"><div class="tt-mg-pick__h"><h2>' + esc(D.s.title) + '</h2><button type="button" class="tt-mg-pick__x" data-x aria-label="' + esc(D.s.close) + '"><svg viewBox="0 0 16 16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M2 2l12 12M14 2L2 14"/></svg></button></div><div class="tt-mg-pick__nav"><div class="tt-mg-pick__fams" role="tablist"></div><div class="tt-mg-pick__bar" aria-hidden="true"><i></i></div></div><div class="tt-mg-pick__grid" role="radiogroup"></div></div>';
        sheet.querySelector('.tt-mg-pick__fams').addEventListener('scroll', bar, { passive: true });
        window.addEventListener('resize', bar);
        document.body.appendChild(sheet);
        sheet.addEventListener('click', function (e) { if (e.target.closest('[data-x]')) closePicker(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) closePicker(); });
      }
      curFam = second.f; drawPicker();
      sheet.classList.add('is-open'); document.documentElement.classList.add('tt-mg-lock');
      var c = sheet.querySelector('.tt-mg-pick__fam[aria-selected="true"]'); if (c) c.scrollIntoView({ inline: 'center', block: 'nearest' });
      // focus the sheet itself, so a tap never paints a keyboard ring on the active tile
      var box = sheet.querySelector('.tt-mg-pick__box'); box.setAttribute('tabindex', '-1'); box.focus({ preventScroll: true });
      bar();
    }
    function closePicker() { sheet.classList.remove('is-open'); document.documentElement.classList.remove('tt-mg-lock'); var o = el.querySelector('[data-tt-mg-open]'); if (o) o.focus(); }
    // the store's switcher bar: the thumb's width is the visible share, its offset the scroll position
    function bar() {
      if (!sheet) return;
      var s = sheet.querySelector('.tt-mg-pick__fams'), b = sheet.querySelector('.tt-mg-pick__bar');
      var over = s.scrollWidth - s.clientWidth;
      b.hidden = over < 4;
      if (over < 4) return;
      var w = s.clientWidth / s.scrollWidth, i = b.firstChild;
      i.style.width = (w * 100) + '%';
      i.style.left = ((s.scrollLeft / over) * (1 - w) * 100) + '%';
    }
    function famImg(k) {
      var l = bags.filter(function (b) { return b.f === k; });
      var b = l.filter(function (x) { return x.a; })[0] || l[0];
      return b ? b.img : '';
    }
    function drawPicker() {
      var fl = sheet.querySelector('.tt-mg-pick__fams'), keep = fl.scrollLeft;
      fl.innerHTML = fams.map(function (f) {
        var n = bags.filter(function (b) { return b.f === f.k && b.a; }).length;
        var count = n === 0 ? D.s.sold : n === 1 ? D.s.colour_one : D.s.colours.replace('{n}', n);
        return '<button type="button" role="tab" class="tt-mg-pick__fam" data-f="' + f.k + '" aria-selected="' + (f.k === curFam) + '">' +
          '<img src="' + famImg(f.k) + '" alt="" width="104" height="112" loading="lazy"><span><b>' + esc(f.n) + '</b><small>' + esc(count) + '</small></span></button>';
      }).join('');
      fl.scrollLeft = keep;
      [].forEach.call(fl.children, function (c) {
        c.addEventListener('click', function () {
          if (curFam === c.getAttribute('data-f')) return;
          curFam = c.getAttribute('data-f'); drawPicker();
          sheet.querySelector('.tt-mg-pick__grid').scrollTop = 0;
          var on = sheet.querySelector('.tt-mg-pick__fam[aria-selected="true"]');
          if (on) on.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
        });
      });
      var grid = sheet.querySelector('.tt-mg-pick__grid');
      var list = bags.filter(function (b) { return b.f === curFam; });
      list.sort(function (a, b) { return (b.a ? 1 : 0) - (a.a ? 1 : 0); });
      grid.innerHTML = list.map(function (b) {
        var p = priceOf(b), c = compareOf(b), on = b.id === second.id;
        var badge = on ? '<span class="tt-mg-pick__b tt-mg-pick__b--on">' + esc(D.s.selected) + '</span>' : (b.a ? '' : '<span class="tt-mg-pick__b">' + esc(D.s.sold) + '</span>');
        return '<button type="button" role="radio" class="tt-mg-pick__card' + (b.a ? '' : ' is-sold') + '" data-id="' + b.id + '" aria-checked="' + on + '"' + (b.a ? '' : ' aria-disabled="true"') + '>' +
          '<span class="tt-mg-pick__m">' + badge + '<img src="' + b.img + '" alt="" loading="lazy" width="400" height="520"></span>' +
          '<span class="tt-mg-pick__t">' + esc(b.t) + '</span>' +
          '<span class="tt-mg-pick__p"><span data-product-id="' + b.id + '" data-variant-id="' + b.v + '">' + money(p) + '</span>' + (c > p ? '<s>' + money(c) + '</s>' : '') + '</span></button>';
      }).join('');
      [].forEach.call(grid.children, function (c) {
        c.addEventListener('click', function () {
          var b = bags.filter(function (x) { return String(x.id) === c.getAttribute('data-id'); })[0];
          if (!b || !b.a) return;
          second = b; err.hidden = true; render(); drawPicker(); setTimeout(closePicker, 180);
        });
      });
      bar();
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }

    /* Add to Cart with two bags */
    var passing = false;
    form.addEventListener('submit', function (e) {
      if (tier !== 2 || T.arm !== 1 || passing) return;
      e.preventDefault(); e.stopImmediatePropagation();
      passing = true;
      var items = [{ id: second.v, quantity: 1 }];
      if (T.giftOk && T.gift) items.push({ id: T.gift, quantity: 1, properties: { _tt_gift: '1' } });
      rawFetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) {
            // The gift itself may be what failed (sold out): retry with the bag alone, the rule sorts the rest.
            if (items.length > 1) {
              return rawFetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify({ items: [items[0]] }) })
                .then(function (r) { return r.json(); });
            }
          }
          return res;
        })
        .then(function (res) {
          if (res && res.status) { err.textContent = D.s.err; err.hidden = false; passing = false; return; }
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          setTimeout(function () { passing = false; }, 900);
        })
        .catch(function () { passing = false; err.textContent = D.s.err; err.hidden = false; });
    }, true);

    render();
    // Intelligems loads late; re-price once its price API is up so a SIV shows the visitor's arm price.
    var tries = 0, t = setInterval(function () { tries++; if ((window.igData && window.igData.price) || tries > 80) { clearInterval(t); render(); } }, 100);
    document.addEventListener('kv:variant-change', render);
  }

  /* ---------- the cart rule ---------- */
  var busy = null, again = false, rounds = 0;
  function readCart() {
    return rawFetch(root + '?sections=tt-mg-cart', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) { var d = new DOMParser().parseFromString(s['tt-mg-cart'] || '', 'text/html').querySelector('[data-tt-mg-cart]'); return JSON.parse(d.textContent); });
  }
  function sync() {
    if (busy) { again = true; return busy; }
    busy = readCart().then(function (cart) {
      var bags = 0, gifts = [];
      cart.lines.forEach(function (l) { if (l.gift) gifts.push(l); else if (l.bag) bags += l.q; });
      if (bags > 0 && T.arm === null) T.assign();
      var have = gifts.reduce(function (n, l) { return n + l.q; }, 0);
      var want;
      if (!T.ok) want = 0;
      else if (T.arm === 1) want = bags >= 2 && T.giftOk ? 1 : 0;
      else if (T.arm === 0) want = 0;
      else want = have > 0 && bags >= 2 ? 1 : 0;   // dormant: keep an earned gift, never add one
      document.documentElement.setAttribute('data-tt-mg-cart', bags + ':' + have + '>' + want);
      if (have === want && gifts.length <= 1) return false;
      if (++rounds > 4) { console.warn('[tt-mg] cart rule stopped after 4 corrections'); return false; }
      var updates = {};
      gifts.forEach(function (l, i) { updates[l.key] = i === 0 ? Math.min(want, 1) : 0; });
      var step = gifts.length ? rawFetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify({ updates: updates }) }) : Promise.resolve();
      return step.then(function () {
        if (want === 1 && !gifts.length) {
          return rawFetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify({ items: [{ id: T.gift, quantity: 1, properties: { _tt_gift: '1' } }] }) });
        }
      }).then(function () { return true; });
    }).then(function (changed) { if (changed) return refresh(); })
      .catch(function () {})
      .then(function () { busy = null; if (again) { again = false; return sync(); } rounds = 0; });
    return busy;
  }
  // Re-render the drawer (and the cart page) in place, without opening the drawer.
  function refresh() {
    var drawer = document.querySelector('cart-drawer');
    var ev = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    if (typeof publish === 'function' && ev) { try { publish(ev.cartUpdate, { source: 'tt-mg' }); } catch (e) {} }
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return;
    var secs = drawer.getSectionsToRender();
    var ids = secs.map(function (s) { return s.section || s.id; });
    return rawFetch(root + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (html) {
        secs.forEach(function (s) {
          var id = s.section || s.id, target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (!target || !html[id]) return;
          var src = new DOMParser().parseFromString(html[id], 'text/html').querySelector(s.selector || '.shopify-section');
          if (src) target.innerHTML = src.innerHTML;
        });
        var inner = drawer.querySelector('.drawer__inner');
        if (inner && drawer.querySelector('.cart-item')) inner.classList.remove('is-empty');
        document.dispatchEvent(new CustomEvent('tt-mg:refreshed'));
      }).catch(function () {});
  }

  var cartWrite = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null;
  function later() { clearTimeout(timer); timer = setTimeout(sync, 250); }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = rawFetch(input, init);
    if (cartWrite.test(url)) p.then(later, function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (cartWrite.test(String(url))) this.addEventListener('loadend', later);
    return xo.apply(this, arguments);
  };

  /* drawer nudge: "Choose a bag" opens the picker when this page has one, else goes to the bags page */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-tt-mg-pick]');
    if (!a) return;
    var open = document.querySelector('[data-tt-mg] [data-tt-mg-open]');
    if (!open) return;
    e.preventDefault();
    var d = document.querySelector('cart-drawer'); if (d && d.close) d.close();
    var two = document.querySelector('[data-tt-mg] .tt-mg__tier--two .tt-mg__radio');
    if (two && !two.checked) { two.checked = true; two.dispatchEvent(new Event('change')); }
    setTimeout(function () { open.click(); }, 300);
  });

  function initAll() { [].forEach.call(document.querySelectorAll('[data-tt-mg]'), initBlock); }
  function boot() {
    initAll();
    // a second render picks up anything parsed after the early start (the sticky button)
    [].forEach.call(document.querySelectorAll('[data-tt-mg]'), function (el) { if (el.__ttRender) el.__ttRender(); });
    sync();
  }
  // Loaded async (2026-10-27): start the block as soon as it and its form are parsed, not when the whole page is.
  if (document.readyState === 'loading') {
    var early = setInterval(function () { initAll(); if (document.readyState !== 'loading') clearInterval(early); }, 50);
    document.addEventListener('DOMContentLoaded', function () { clearInterval(early); boot(); });
  } else boot();
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
})();
